// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oQkz","left":"styles_left__1aKn8"};